import { ADD_MESSAGE, REMOVE_MESSAGE, TOGGLE_LOADING } from "../actions/types";
const initialState = {
  messages: [],
  loading: false,
  loadingMessage: "Loading...",
};
export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_MESSAGE:
      return {
        ...state,
        messages: [action.payload, ...state.messages],
      };
    case REMOVE_MESSAGE:
      return {
        ...state,
        messages: state.messages.filter((message) => message.id !== action.payload),
      };
    case TOGGLE_LOADING:
      return {
        ...state,
        loading: action.payload.status,
        loadingMessage: action.payload.loadingMessage,
      };
    default:
      return state;
  }
}
